 
// src/components/Login.js 
import React, { useState } from "react"; 
import { signInWithEmailAndPassword } from "firebase/auth"; 
import { doc, getDoc } from "firebase/firestore"; 
import { auth, db } from "../firebase"; 
import "./Login.css"; 
const Login = ({ onLoginSuccess }) => { 
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [loading, setLoading] = useState(false); 
  const [error, setError] = useState(""); 
  const handleLogin = async (e) => { 
    e.preventDefault(); 
    setError(""); 
    setLoading(true); 
    try { 
      /* 
      |-------------------------------------------------------------------------- 
      | Firebase Authentication 
      |-------------------------------------------------------------------------- 
      */ 
      const userCredential = await signInWithEmailAndPassword( 
        auth, 
        email.trim(), 
        password 
      ); 
      const user = userCredential.user; 
      /* 
      |-------------------------------------------------------------------------- 
      | 1. EXISTING ADMIN LOGIN 
      |-------------------------------------------------------------------------- 
      */ 
      const adminRef = doc(db, "admin-users", user.uid); 
      const adminSnap = await getDoc(adminRef); 
      let userData = null; 
      let role = null; 
      if (adminSnap.exists()) { 
        role = "admin"; 
        userData = { 
          ...adminSnap.data(), 
          uid: user.uid, 
          email: user.email, 
          role 
        }; 
      } 
      /* 
      |-------------------------------------------------------------------------- 
      | 2. EXISTING PARTNER LOGIN 
      |-------------------------------------------------------------------------- 
      */ 
      else if (user.uid === "eBdMwBiLYvZkUQsoQhjIYrpmlSk2") { 
        role = "partner"; 
        userData = { 
          email: user.email, 
          uid: user.uid, 
          role 
        }; 
      } 
      /* 
      |-------------------------------------------------------------------------- 
      | 3. INVITED EMPLOYEE LOGIN 
      |-------------------------------------------------------------------------- 
      | 
      | Cloud Function creates: 
      | Invite Users 
      |      ↓ 
      | Document ID = Firebase Auth UID 
      | 
      */ 
      else { 
        const inviteUserRef = doc( 
          db, 
          "Invite Users", 
          user.uid 
        ); 
        const inviteUserSnap = await getDoc(inviteUserRef); 
        if (inviteUserSnap.exists()) { 
          const inviteData = inviteUserSnap.data(); 
 
          /* 
          |-------------------------------------------------------------------------- 
          | Check employee account status 
          |-------------------------------------------------------------------------- 
          */ 
          if (inviteData.disabled === true) { 
            setError( 
              "Your account has been disabled. Contact admin." 
            ); 
            await auth.signOut(); 
            return; 
          } 
          /* 
          |-------------------------------------------------------------------------- 
          | Employee role 
          |-------------------------------------------------------------------------- 
          */ 
          role = inviteData.role || "employee"; 
          userData = { 
            ...inviteData, 
            uid: user.uid, 
            email: 
              inviteData.email || 
              user.email, 
            displayName: 
              inviteData.displayName || 
              user.displayName || 
              "", 
            role, 
            accountType: 
              inviteData.accountType || 
              "employee", 
            status: 
              inviteData.status || 
              "invited" 
          }; 
        } 
      } 
      /* 
      |-------------------------------------------------------------------------- 
      | USER NOT FOUND 
      |-------------------------------------------------------------------------- 
      | 
      | If the authenticated Firebase user is not found in: 
      | 
      | 1. admin-users 
      | 2. partner UID 
      | 3. Invite Users 
      | 
      */ 
      if (!userData) { 
        setError( 
          "User not found. Contact admin." 
        ); 
        await auth.signOut(); 
        return; 
      } 
      /* 
      |-------------------------------------------------------------------------- 
      | LOGIN SUCCESS 
      |-------------------------------------------------------------------------- 
      */ 
      console.log("✅ Login successful"); 
      console.log("UID:", user.uid); 
      console.log("Email:", user.email); 
      console.log("Role:", role); 
      alert("✅ Login successful!"); 
      onLoginSuccess({ 
        ...userData, 
        role 
      }); 
 
    } catch (err) { 
      console.error( 
        "❌ Login Error:", 
        err 
      ); 
 
      /* 
      |-------------------------------------------------------------------------- 
      | Friendly Firebase Authentication errors 
      |-------------------------------------------------------------------------- 
      */ 
      if (err.code === "auth/invalid-credential") { 
        setError( 
          "Invalid email or password." 
        ); 
      } 
      else if (err.code === "auth/user-not-found") { 
        setError( 
          "No account exists with this email address." 
        ); 
      } 
      else if (err.code === "auth/wrong-password") { 
        setError( 
          "Incorrect password." 
        ); 
      } 
      else if (err.code === "auth/invalid-email") { 
        setError( 
          "Please enter a valid email address." 
        ); 
      } 
      else if (err.code === "auth/user-disabled") { 
        setError( 
          "This Firebase account has been disabled." 
        ); 
      } 
      else { 
        setError( 
          err.message || 
          "Unable to log in. Please try again." 
        ); 
      } 
 
    } finally { 
      setLoading(false); 
    } 
  }; 
  return ( 
    <div className="login-page"> 
      <div className="login-container"> 
        {/* Login Image */} 
        <div 
          style={{ 
            textAlign: "center", 
            marginBottom: "20px" 
          }} 
        > 
          <img 
            src="/ChatGPT Image May 20, 2026, 05_18_26 PM.png" 
            alt="Login Banner" 
            style={{ 
              width: "180px", 
              height: "180px", 
              objectFit: "contain", 
              borderRadius: "12px" 
            }} 
          /> 
        </div> 
        <h2> 
          Login to your Dashboard 
        </h2> 
        <form 
          onSubmit={handleLogin} 
          className="login-form" 
        > 
          <input 
            type="email" 
            placeholder="Email" 
            value={email} 
            onChange={(e) => 
              setEmail(e.target.value) 
            } 
            required 
            autoComplete="email" 
          /> 
          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => 
              setPassword(e.target.value) 
            } 
            required 
            autoComplete="current-password" 
          /> 
          <button 
            type="submit" 
            disabled={loading} 
          > 
            {loading 
              ? "Logging in..." 
              : "Log In"} 
          </button> 
        </form> 
        {error && ( 
          <p className="error-message"> 
            {error} 
          </p> 
        )} 
      </div> 
    </div> 
  ); 
}; 
export default Login; 
